module.exports = __webpack_public_path__ + "img/Step2-m.0abbb4d.svg";